import React, { useEffect, useState } from "react";
import { AlertCircle } from "react-feather";
import { emailTypoFix } from "../utility/emailTypos";
import { useCheckoutT } from "../i18n/checkout";
import "./EmailTypoHint.css";

// Under an email field, when the address looks misspelled (utility/emailTypos):
// "Please check your email. Did you mean ana@gmail.com?" and a button that puts
// it in. It doesn't stop them (the address may be right). It waits until they
// stop typing a moment, so "@gmail.co" on the way to ".com" says nothing.
const EmailTypoHint = ({ email, onFix }) => {
  const { t } = useCheckoutT();
  const [settled, setSettled] = useState(email);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(email), 900);
    return () => clearTimeout(timer);
  }, [email]);
  const fix = settled === email ? emailTypoFix(email) : null;
  if (!fix) return null;
  return (
    <p className="emailTypo" role="alert" data-testid="email-typo">
      <AlertCircle aria-hidden="true" />
      <span>
        {t("email.typoCheck", { fix })}{" "}
        <button type="button" className="emailTypoFix" onClick={() => onFix(fix)} data-action="fix-email">{t("email.typoFix")}</button>
      </span>
    </p>
  );
};

export default EmailTypoHint;
